import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageCountHandlerComponent } from './page-count-handler/page-count-handler.component';



@NgModule({
  declarations: [PageCountHandlerComponent],
  imports: [
    CommonModule
  ],
  exports: [PageCountHandlerComponent]
})
export class SharedModule { }
